import React from 'react';
import './ServicesTabView.less';
import {
  isBND,
  isCTF,
  isFRM,
  isLocalizeAdded,
  isTLA,
  isSPS,
  isMVV,
  LocalizePropType,
  isGRF,
  isOSN,
  isSCT,
  TariffData,
  selectUser,
} from 'getaway-data-layer';
import ServiceItem from '../../../../components/ServiceItem/ServiceItem';
import { openLink } from '../../../../../utils';
import { useSelector } from 'react-redux';

type Props = {
  localize: LocalizePropType;
  merchantSystemData: any;
  isORG: boolean;
  tariff: TariffData;
  email: string;
  paymentAccount?: any;
  sepa?: any;
  onClickTariffPartner: () => void;
};

const mapMerchantToService = (merchantName, isEbusOnly, tlaAndCtf) => {
  const mapping = {
    BND: { HAL: 'bnd', eBUS: isEbusOnly ? 'bnd' : 'cityflitzer' },
    FRM: { eBUS: 'FRM' },
    MVV: { eBUS: 'MVV' },
    CTF: tlaAndCtf ? { eBUS: 'TIL' } : { eBUS: 'ctf', TIL: 'TIL' },
    TLA: { eBUS: 'TIL' },
    SPS: { HAL: 'sps' },
    GRF: { eBUS: 'grf' },
    OSN: { eBUS: 'osn' },
    SCT: { eBUS: 'sct' },
  };

  if (isBND() && mapping.BND[merchantName]) return mapping.BND[merchantName];
  if (isFRM() && mapping.FRM[merchantName]) return mapping.FRM[merchantName];
  if (isMVV() && mapping.MVV[merchantName]) return mapping.MVV[merchantName];
  if (isCTF() && mapping.CTF[merchantName]) return mapping.CTF[merchantName];
  if (isTLA() && mapping.TLA[merchantName]) return mapping.TLA[merchantName];
  if (isSPS() && mapping.SPS[merchantName]) return mapping.SPS[merchantName];
  if (isGRF() && mapping.GRF[merchantName]) return mapping.GRF[merchantName];
  if (isOSN() && mapping.OSN[merchantName]) return mapping.OSN[merchantName];
  if (isSCT() && mapping.SCT[merchantName]) return mapping.SCT[merchantName];
};

const ServicesTabView = ({
  localize,
  merchantSystemData,
  isORG,
  tariff,
  email,
  paymentAccount,
  sepa,
  onClickTariffPartner,
}: Props) => {
  const user = useSelector(selectUser);
  const isTlaAndCtf = isCTF() && user?.tariff?.name?.includes('teilauto');
  const merchantSystems = isCTF()
    ? [...merchantSystemData, { merchantSystem: 'TIL', status: 'PENDING' }]
    : merchantSystemData;

  const isEbusOnly =
    merchantSystems?.length === 1 &&
    merchantSystems?.[0]?.merchantSystem === 'eBUS';

  return (
    <div>
      {merchantSystems?.map((merchant, index) => {
        const service = mapMerchantToService(
          merchant?.merchantSystem,
          isEbusOnly,
          isTlaAndCtf
        );

        return (
          service && (
            <ServiceItem
              key={merchant?.merchantName}
              localize={localize}
              title={localize(
                isTlaAndCtf
                  ? 'service.TLA.CTF.title'
                  : `service.${service}.title`
              )}
              logo={`/images/${service}-logo.png`}
              background={`/images/${service}-bg.png`}
              description={localize(`service.${service}.desc`)}
              provider={localize(`service.${service}.provider`)}
              customerNr={merchant?.merchantReference || './.'}
              PIN={
                ['DONE', 'IMPORTED'].includes(merchant?.status)
                  ? merchant?.pin
                  : './.'
              }
              onClickLogin={openLink(localize(`service.${service}.login.link`))}
              onClickImprint={openLink(
                localize(`service.${service}.imprint.link`)
              )}
              onClickDataProtection={openLink(
                localize(`service.${service}.data.link`)
              )}
              onClickAGB={openLink(localize(`service.${service}.agb.link`))}
              verified={['DONE', 'IMPORTED'].includes(merchant?.status)}
              timestamp={merchant?.syncedAt}
              tariff={tariff}
              email={email}
              sepa={sepa}
              paymentAccount={paymentAccount}
              tariffPartnerLink={
                isLocalizeAdded(
                  localize,
                  isORG
                    ? `service.tariff.partner.org.link`
                    : `service.tariff.partner.org`
                )
                  ? localize(
                      isORG
                        ? `service.tariff.partner.org.link`
                        : `service.tariff.partner.org`
                    )
                  : undefined
              }
              note={
                merchant?.status === 'ERROR' &&
                merchant?.error?.includes('Unknown mainCustomerHash')
                  ? localize('service.tariff.mainPartnerTerminated')
                  : merchant?.status === 'ERROR' &&
                    merchant?.error?.includes('maxPartnersExceeded')
                  ? localize('service.tariff.maxPartnersExceeded')
                  : isLocalizeAdded(
                      localize,
                      isORG
                        ? `service.${service}.org.note`
                        : `service.${service}.note`
                    ) && !isTlaAndCtf
                  ? localize(
                      isORG
                        ? `service.${service}.org.note`
                        : `service.${service}.note`
                    )
                  : undefined
              }
              isORG={isORG}
              firstItem
              lastItem
              onClickTariffPartner={onClickTariffPartner}
            />
          )
        );
      })}
    </div>
  );
};

export default ServicesTabView;
